import { render } from "./cdrBatchManagement.vue?vue&type=template&id=a5a3d9f0&scoped=true"
import script from "./cdrBatchManagement.vue?vue&type=script&lang=js"
export * from "./cdrBatchManagement.vue?vue&type=script&lang=js"

import "./cdrBatchManagement.vue?vue&type=style&index=0&id=a5a3d9f0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a5a3d9f0"

export default script